module.exports = __webpack_public_path__ + "img/2a47150.png";